import { Paragraph } from 'src/interviews/components/Layout/Embedded';

export default function BulletList({ items }: { items: string[] }) {
  return (
    <ul className="bp-pl-7 bp-pt-5">
      {items.map((item: string, index: number) => (
        <li key={`${item}-${index}`} className="bp-list-disc">
          <Paragraph className="BuoyInterviews__Question__parsedQuestion">
            <strong>{item}</strong>
          </Paragraph>
        </li>
      ))}
    </ul>
  );
}
